export function handleOnPasteCaptureNumbers(e) {
  const nextValue = e.clipboardData.getData("text/plain");
  if (Number.isNaN(+nextValue)) return e.preventDefault();
}
